import { render } from "./LogsDetailClinton.vue?vue&type=template&id=67dbeece"
import script from "./LogsDetailClinton.vue?vue&type=script&lang=js"
export * from "./LogsDetailClinton.vue?vue&type=script&lang=js"

import "./LogsDetailClinton.vue?vue&type=style&index=0&id=67dbeece&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__